import { applyMiddleware, createStore } from 'redux'
import reducers from '../reducers/index'
import thunk from 'redux-thunk'
const { createLogger } = require(`redux-logger`)
// import {loadState, saveState} from "./localStorage";

//const persistedState = loadState();

let logger = createLogger({
    predicate: (getState, action) => process.env.NODE_ENV === 'development',
})

const store = createStore(
    reducers,
    //persistedState,
    applyMiddleware(thunk, logger)
)
//
// const listenToWindowEvent =
//     (name, mapEventToAction) =>
//         (dispatch) =>
//             window.addEventListener(name, (e)=> dispatch(mapEventToAction(e)));
//
// const navigatorOnLine = (e) => ({type: 'WEB_APP_ONLINE',payload: navigator.onLine});
//
// if(listenToWindowEvent){
//     store.dispatch(listenToWindowEvent('load', navigatorOnLine));
//     store.dispatch(listenToWindowEvent('offline', navigatorOnLine));
//     store.dispatch(listenToWindowEvent('online', navigatorOnLine));
// }
export default store
